import {ParkingLotDto} from '@lib/infrastructure';

export const transformToBuildingIdMap = (parkingLots: ParkingLotDto[]): Map<string, ParkingLotDto[]> => {
  const buildingIdMap = new Map<string, ParkingLotDto[]>();

  parkingLots.forEach((lot) => {
    lot.buildingIds.forEach((buildingId) => {
      if (!buildingIdMap.has(buildingId)) {
        buildingIdMap.set(buildingId, []);
      }
      buildingIdMap.get(buildingId)?.push(lot);
    });
  });

  return buildingIdMap;
};
